var promise = require('shared').promise;

function alwaysTrue() {
	var def = promise();
	def.resolve();
	return def.promise;
}

module.exports = alwaysTrue;